import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./components/Dashboard";
import CarbonCredits from "./pages/CarbonCredits";
import PerformanceMetrics from "./pages/PerformanceMetrics";
import LegalCompliance from "./pages/LegalCompliance";
import Layout from "./components/Layout"; 
import UserManagement from "./pages/UserManagement";

import { ThemeProvider } from "./context/ThemeContext"; 

const App = () => {
    // Store token in state (starts as null)
    const [token, setToken] = useState(null);

    // Ensure token updates when login/logout happens
    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        setToken(storedToken); // Update state

        // Listen for changes (like logout in another tab)
        const handleStorageChange = () => {
            setToken(localStorage.getItem("token")); 
        };

        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);



    return (
        <Router>
            {/*{token === null ? <Navigate to="/login" replace /> : null}*/}
            <ThemeProvider> {/* Wrap inside Router for better integration */}
                <Routes>
                    {/* Public Pages */}
                    <Route path="/login" element={token ? <Navigate to="/dashboard" /> : <Login />} />
                    <Route path="/register" element={ <Register />} />

                    {/* Protected Pages Wrapped in Layout */}
                    <Route element={token ? <Layout /> : <Navigate to="/login" />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/carbon-credits" element={<CarbonCredits />} />
                        <Route path="/performance" element={<PerformanceMetrics />} />
                        <Route path="/legal" element={<LegalCompliance />} />
                        <Route path="/admin/users" element={<UserManagement />} />
                    </Route>

                    

                    {/* Redirect unknown routes to login */}
                    <Route path="*" element={<Navigate to={token ? "/dashboard" : "/login"} />} />
                </Routes>
            </ThemeProvider>
        </Router>
    );
};

export default App;
